import React, { useState } from "react";
import Navbar from "./components/Navbar";
import NewsLetter from "./components/NewsLetter";
import "./css/Home.css";

import heroBg from "../images/forum-banner.jpg";
import heroImage from "../images/forumicon1.png";


// New Section Image (Update path to your actual image)
import aboutImage1 from "../images/forumicon2.png";
import aboutImage2 from "../images/forumicon3.png";
import aboutImage3 from "../images/forumicon4.png";



import twinBg from "../images/Banner3.png"; // New background image asset
import circle2Icon1 from "../images/HomeIcon.png"; // Icon for the first circle
import circle2Icon2 from "../images/HomeIcon.png"; // Icon for the second circle



import Footer from "./components/Footer";

import DownloadApp from "./components/DownloadApp";

function Forum() {

    return (
        <>
            {/* Existing Hero Section */}
            <section
                className="hero-section"
                style={{
                    backgroundImage: `url(${heroBg})`,
                }}
            >
                <Navbar />

                <div className="container hero-content">
                    <div className="row align-items-center">
                        {/* Left Section (Increased Width) */}
                        <div className="col-lg-7 col-md-12 mb-4 mb-lg-0">
                            <div className="hero-left">
                                <p className="hero-small-text">Welcome to Crestest Forum</p>

                                <h1 className="hero-heading">
                                    Academic Synergy for Smarter Learning
                                </h1>

                                <p className="hero-sub-text" style={{ color: "white" }}>
                                    Cultivate brilliance, build meaningful social connections, and shape the
                                    future of academic excellence through collaborative learning and knowledge sharing.
                                </p>

                                <a
                                    href="https://forum.crestest.com/login"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn " style={{
                                        backgroundColor: "#0e5483",
                                        color: "#fff",
                                        border: "none"
                                    }}
                                >
                                    JOIN THE FORUM
                                </a>
                            </div>
                        </div>

                        {/* Right Section (Circles) */}
                        <div className="col-lg-5 col-md-12">
                            <div className="hero-right hero-full-image">
                                <img
                                    src={heroImage}
                                    alt="Hero Main"
                                    className="hero-full-width-img"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            {/* 3. Group Discussion Section */}
            <section className="info-section">
                <div className="container">
                    <div className="row align-items-stretch">

                        {/* Left Side Content */}
                        <div className="col-lg-6 d-flex align-items-center">
                            <div className="info-left-content">
                                <p className="info-small-text">GROUP DISCUSSION</p>

                                <h2 className="info-heading">
                                    Connect, Collaborate & Grow with Crestest Forum
                                </h2>

                                {/* The Zigzag Accent */}
                                <div className="zigzag-border mb-3"></div>

                                <p className="info-sub-text">
                                    Crestest Forum is a collaborative platform where open discussions spark innovation, encourage meaningful conversations, and help learners exchange ideas in a supportive academic community.
                                </p>

                                <p className="info-sub-text mt-3">
                                    Build valuable connections, solve problems together, and grow through shared knowledge in a safe and welcoming environment that promotes both personal and academic excellence.
                                </p>

                                <a
                                    href="https://forum.crestest.com/login"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn info-btn mt-3"
                                >
                                    JOIN THE FORUM
                                </a>
                            </div>
                        </div>

                        {/* Right Side Image */}
                        <div className="col-lg-6 px-0">
                            <div className="info-right-img-wrap">
                                <img
                                    src={aboutImage1}
                                    alt="Crestest Forum"
                                    className="info-full-image"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>



            {/* 7. NEW: Overlapping Dual Card Section */}
            {/* <section
                className="twin-cards-section"
                style={{ backgroundImage: `url(${twinBg})` }}
            >
                <div className="container">

                    <div className="row justify-content-center text-center twin-header-margin">
                        <div className="col-lg-8 d-flex flex-column align-items-center">
                            <p className="cards-small-text">WHY CRESTEST</p>
                            <h2 className="cards-main-heading">
                                Smarter Learning, Better Results
                            </h2>
                            <div className="zigzag-border"></div>
                        </div>
                    </div>

                    <div className="row g-5 justify-content-center twin-row-padding">

                        <div className="col-md-6 col-lg-5">
                            <div className="overlap-card">

                                <div className="floating-top-circle bg-circle-accent1">
                                    <img src={circle2Icon1} alt="AI-Powered Learning" className="floating-circle-icon" />
                                </div>

                                <div className="overlap-card-body text-center d-flex flex-column align-items-center">
                                    <p className="overlap-sub-text">
                                        Personalized AI-driven learning, smart practice, and detailed performance insights help students strengthen concepts and improve results.
                                    </p>
                                    <span className="overlap-colored-action">
                                        AI-POWERED LEARNING
                                    </span>
                                </div>

                            </div>
                        </div>

                        <div className="col-md-6 col-lg-5">
                            <div className="overlap-card">

                                <div className="floating-top-circle bg-circle-accent2">
                                    <img src={circle2Icon2} alt="Complete Learning Ecosystem" className="floating-circle-icon" />
                                </div>

                                <div className="overlap-card-body text-center d-flex flex-column align-items-center">
                                    <p className="overlap-sub-text">
                                        From online exams and e-Library resources to performance analytics and academic challenges, Crestest provides a complete learning ecosystem.
                                    </p>
                                    <span className="overlap-colored-action highlight-action-yellow">
                                        COMPLETE ECOSYSTEM
                                    </span>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section> */}

            {/* Quiz Section */}
            <section className="info-section">
                <div className="container">
                    <div className="row align-items-stretch">

                        {/* Left Side Image */}
                        <div className="col-lg-6 px-0 order-lg-1 order-2">
                            <div className="info-right-img-wrap">
                                <img
                                    src={aboutImage2}
                                    alt="Crestest Quiz"
                                    className="info-full-image"
                                />
                            </div>
                        </div>

                        {/* Right Side Content */}
                        <div className="col-lg-6 d-flex align-items-center order-lg-2 order-1">
                            <div className="info-left-content">
                                <p className="info-small-text">QUIZ</p>

                                <h2 className="info-heading">
                                    Challenge Yourself with Interactive Quizzes
                                </h2>

                                {/* Zigzag Accent */}
                                <div className="zigzag-border mb-3"></div>

                                <p className="info-sub-text">
                                    Crestest Forum offers engaging quizzes designed to encourage participation, strengthen concepts, and make learning both enjoyable and competitive. Every quiz helps learners assess their knowledge while building confidence.
                                </p>

                                <p className="info-sub-text mt-3">
                                    More than just testing knowledge, quizzes inspire critical thinking, healthy competition, and continuous improvement, motivating every participant to achieve greater academic success.
                                </p>

                                <a
                                    href="https://forum.crestest.com/login"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn info-btn mt-3"
                                >
                                    START QUIZZING
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Download App Section */}
            <DownloadApp />

            {/* Members Section */}
            <section className="info-section">
                <div className="container">
                    <div className="row align-items-stretch">

                        {/* Left Side Content */}
                        <div className="col-lg-6 d-flex align-items-center">
                            <div className="info-left-content">
                                <p className="info-small-text">MEMBERS</p>

                                <h2 className="info-heading">
                                    Join a Community That Inspires Growth & Innovation
                                </h2>

                                {/* Zigzag Accent */}
                                <div className="zigzag-border mb-3"></div>

                                <p className="info-sub-text">
                                    Crestest Forum is an exclusive community where every member's contribution helps shape the future of learning. Share ideas, exchange knowledge, and become part of a vibrant academic network.
                                </p>

                                <p className="info-sub-text mt-3">
                                    Guided by dedicated moderators, students collaborate through meaningful discussions that inspire innovation, build lasting connections, and transform learning into a journey of empowerment and discovery.
                                </p>

                                <a
                                    href="https://forum.crestest.com/login"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn info-btn mt-3"
                                >
                                    BECOME A MEMBER
                                </a>
                            </div>
                        </div>

                        {/* Right Side Image */}
                        <div className="col-lg-6 px-0">
                            <div className="info-right-img-wrap">
                                <img
                                    src={aboutImage3}
                                    alt="Crestest Forum Members"
                                    className="info-full-image"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>







            {/* 8. NEW: Modular Newsletter Component */}
            <NewsLetter />

            {/* 9. NEW: Footer Component */}
            <Footer />
        </>
    );
}

export default Forum;